/** Microsoft 365 in Yönetim › Entegrasyonlar and Denetim kaydı (Phase 15e). */
export const m365AdminTr = {
  name: 'Microsoft 365',
  readOnly: 'yalnız okuma',
  products: { both: 'Outlook mail ve takvim', mail: 'Outlook mail', calendar: 'Outlook takvim', none: 'Outlook', onedrive: 'OneDrive', sharepoint: 'SharePoint' },
  status: {
    not_set_up: 'Kurulmadı',
    incomplete: 'Kurulum tamamlanmadı',
    off: 'Firmada kapalı',
    failing: 'Test başarısız',
    working: 'Çalışıyor',
  },
  unsupported: 'Microsoft 365 yalnız firmalarda kullanılır; kişisel alanda kurulamaz.',
  copy: 'Kopyala',
  copied: 'Kopyalandı',
  overview: {
    title: 'Hazır bağlantılar',
    hint: 'Oppy ile gelir. Kurup firmada açtığınızda çalışanlar kendi Microsoft hesaplarıyla bağlanır.',
    notSetUp: 'Bir kez kurulur; sonra her çalışan kendi hesabını bağlar.',
    connected_one: 'Şu an {{count}} kişi bağlı',
    connected_other: 'Şu an {{count}} kişi bağlı',
    firmOn: 'Firmada açık',
    firmOff: 'Firmada kapalı',
    setUp: 'Kur',
    manage: 'Yönet',
    resume: 'Kuruluma devam et',
    catalog: 'Eklenen bağlantılar',
  },
  testCodes: {
    tenant_not_found: { title: 'Kiracı bulunamadı', action: "Kiracı kimliğini Microsoft'taki kaydın “Genel bakış” sayfasıyla karşılaştırın." },
    app_not_found: { title: 'Uygulama bu kiracıda bulunamadı', action: 'Uygulama kimliğini ve kiracı kimliğini kontrol edin; kayıt bu kiracıda olmalı.' },
    bad_secret: { title: 'Gizli anahtar yanlış', action: '“Değer” sütununu kopyaladığınızdan emin olun; “Gizli dizi kimliği” değil.' },
    secret_expired: { title: 'Gizli anahtarın süresi dolmuş', action: "Microsoft'ta yeni bir istemci gizli dizisi oluşturup 2. adımda girin." },
    no_secret: { title: 'Gizli anahtar girilmemiş', action: 'Doğrudan giriş için 2. adımda gizli anahtarı girin.' },
    public_client_disabled: { title: 'Kodla giriş kayıtta kapalı', action: 'Kayıtta Kimlik doğrulama › Ayarlar › “Genel istemci akışlarına izin ver” = Etkin olmalı.' },
    redirect_not_https: { title: 'Dönüş adresi https değil', action: 'Bu adresle Doğrudan giriş çalışmaz; “Kodla”yı seçin ya da sunucuya https adresi verin.' },
    unreachable: { title: "Sunucu Microsoft'a ulaşamadı", action: "Güvenlik duvarında login.microsoftonline.com ve graph.microsoft.com'a 443 çıkışını açın, sonra yeniden deneyin." },
    unexpected: { title: 'Microsoft beklenmeyen bir yanıt verdi', action: 'Biraz sonra yeniden deneyin; sürerse kaydın ayarlarını kontrol edin.' },
  },
  setup: {
    title: 'Microsoft 365 kurulumu',
    intro: 'Bir kez yapılır, yaklaşık 15 dakika. Gizli anahtar sunucunuzda şifreli saklanır.',
    stepsLabel: 'Kurulum adımları',
    steps: { s1: "Microsoft'ta kayıt açın", s2: 'Bilgileri girin', s3: 'Yönetici onayı', s4: 'Test edin' },
    stepTitle: '{{n}} · {{title}}',
    stepDone: 'tamamlandı',
    back: 'Geri',
    next: 'Devam et',
    register: {
      intro:
        'Microsoft Entra yönetim merkezinde (entra.microsoft.com) Oppy için bir uygulama kaydı kullanın: varsa mevcut kaydınızı (Entra ID › Uygulama kayıtları › Tüm uygulamalar), yoksa “Yeni kayıt” ile yenisini açın. Kayda şunları ekleyin:',
      redirect: { title: 'Dönüş adresi', text: "Kimlik doğrulama › Yeniden yönlendirme URI'si ekle › Web. Adresi 2. adımda Kopyala ile alırsınız." },
      permissions: { title: 'Okuma izinleri', text: 'API izinleri › İzin ekle › Microsoft Graph › Temsilci izinleri: User.Read, Mail.Read, Calendars.Read (openid, profile ve offline_access da listede olsun).' },
      consent: { title: 'Yönetici onayı', text: 'Aynı sayfada “… için yönetici onayı ver”: listedeki bütün izinleri onaylar. 3. adımdaki düğme yalnız okuma izinlerini ister.' },
      secret: { title: 'Gizli anahtar', text: 'Sertifikalar ve gizli diziler › Yeni istemci gizli dizisi. “Değer” sütununu kopyalayın; Microsoft onu yalnız bir kez gösterir.' },
      noAppPermissions: 'Uygulama izinleri (Application permissions) eklemeyin: Oppy her zaman kişinin kendi adına çalışır ve yalnız okur.',
      guide: 'Adım adım',
      guideSteps: {
        s1: 'entra.microsoft.com’da Entra ID › Uygulama kayıtları › Tüm uygulamalar’ı açın. Mevcut kaydı seçin ya da “Yeni kayıt” ile açın: ad “Oppy”, hesap türü “Yalnızca bu kuruluş dizinindeki hesaplar”.',
        s2: 'Kaydın “Genel bakış” sayfasında “Uygulama (istemci) kimliği” ve “Dizin (kiracı) kimliği”ni not edin; 2. adımda girilecek.',
        s3: "Kimlik doğrulama › Yeniden yönlendirme URI'si ekle › Web: 2. adımdaki dönüş adresini ekleyin (eski görünümde Platform ekle › Web). Kayıtta başka adresler varsa silmeyin.",
        s4: 'API izinleri › İzin ekle › Microsoft Graph › Temsilci izinleri: User.Read, Mail.Read, Calendars.Read, openid, profile, offline_access.',
        s5: 'Sertifikalar ve gizli diziler › Yeni istemci gizli dizisi: bir süre seçin, “Değer”i kopyalayın ve bitiş tarihini not edin.',
        s6: 'Yalnız “Kodla” giriş kullanacaksanız: Kimlik doğrulama › Ayarlar › “Genel istemci akışlarına izin ver” = Etkin.',
      },
    },
    details: {
      intro: "Microsoft'taki kaydınızın “Genel bakış” sayfasından kopyalayın.",
      tenantId: 'Kiracı kimliği',
      tenantIdHint: "Microsoft'ta: Dizin (kiracı) kimliği",
      clientId: 'Uygulama kimliği',
      clientIdHint: "Microsoft'ta: Uygulama (istemci) kimliği",
      guidPlaceholder: '00000000-0000-0000-0000-000000000000',
      guidError: "Microsoft'taki gibi 8-4-4-4-12 biçiminde olmalı (ör. 3f2a9c1e-5d7b-4c2e-9a10-…).",
      secret: 'Gizli anahtar',
      secretHint: "Microsoft'ta: Sertifikalar ve gizli diziler › Yeni istemci gizli dizisi",
      secretPlaceholder: 'Yapıştırın; kaydedince bir daha gösterilmez',
      secretReplace: 'Değiştirmek için yenisini yapıştırın; boş bırakırsanız kayıtlı anahtar kalır',
      secretSaved: 'Kayıtlı gizli anahtar var',
      secretRequired: 'Doğrudan giriş için gizli anahtar gerekir.',
      secretOptional: 'Kodla girişte gerekmez.',
      expires: 'Gizli anahtar bitişi (isteğe bağlı)',
      expiresHint: 'Microsoft gizli diziyi oluştururken gösterir; özet sayfası bitişten önce uyarır. Yeni anahtar girdiyseniz bunu da güncelleyin.',
      redirectTitle: "Bunu da Microsoft'taki kayda ekleyin",
      redirectPath: "Kimlik doğrulama › Yeniden yönlendirme URI'si ekle › Web",
      redirectHttp:
        'Bu adres https değil. Microsoft “Doğrudan” giriş için yalnız https (ya da localhost) dönüş adreslerini kabul eder; sunucunuzun https adresi yoksa aşağıdan “Kodla”yı seçin.',
      method: 'Gelişmiş: giriş yöntemi',
      methodHint: 'Varsayılan “Doğrudan”. Sunucunuzun https adresi yoksa “Kodla” seçilebilir.',
      methodLabel: 'Giriş yöntemi',
      methods: {
        auth_code: { title: 'Doğrudan', hint: "Çalışan Microsoft'un sayfasında girer ve Oppy'ye kendiliğinden döner. https adresi gerekir." },
        device_code: { title: 'Kodla', hint: "Çalışan Oppy'nin gösterdiği kodu Microsoft'un sayfasına yazar. Kayıtta “Genel istemci akışlarına izin ver” açık olmalı." },
      },
      recommended: 'Önerilen',
      save: 'Kaydet ve devam et',
      resetTitle: 'Kiracı ya da uygulama değişiyor',
      resetBody_one: '{{count}} kişinin Microsoft bağlantısı kaldırılır ve anahtarı silinir; yeniden bağlanması gerekir.',
      resetBody_other: '{{count}} kişinin Microsoft bağlantısı kaldırılır ve anahtarları silinir; her birinin yeniden bağlanması gerekir.',
      resetConfirm: 'Kaydet ve bağlantıları kaldır',
    },
    consent: {
      intro: "Çalışanların kendi hesaplarıyla bağlanabilmesi için Microsoft'ta bir yönetici bu okuma izinlerine bir kez onay verir.",
      who: "Bunu Microsoft'ta genel yönetici ya da bulut uygulama yöneticisi yapabilir; değilseniz bu adımı o kişiyle birlikte yapın.",
      permissions: { user: 'Kişinin adı ve e-posta adresi', mail: 'Mailleri okumak', calendar: 'Takvimi okumak' },
      button: "Microsoft'ta yönetici onayı ver",
      noRedirectTitle: "Onayı Microsoft'taki kayıtta verin",
      noRedirect: 'Bu kurulumun adresi https olmadığı için Microsoft buraya dönemez. Kayıtta API izinleri › “… için yönetici onayı ver” düğmesini kullanın.',
      already: "Onayı Microsoft'taki kayıtta verdiyseniz bu adımı geçin.",
    },
    test: {
      intro: "Oppy kiracıyı, uygulama kimliğini ve gizli anahtarı Microsoft'ta dener; hiçbir çalışanın verisini okumaz.",
      button: 'Test et',
      ok: 'Bağlantı çalışıyor',
      answer: 'Microsoft {{seconds}} sn içinde yanıt verdi.',
      fix: 'Bilgileri düzelt',
      openGuide: 'Adım adım’a bak',
      finishTitle: 'Kurulum bitti',
      finishOff: 'Çalışanların kullanabilmesi için özet sayfasında “Firmada açık” anahtarını açın.',
      finishOn: 'Çalışanlar Bağlantılar sayfasından kendi hesaplarını bağlayabilir.',
      toSummary: 'Özete git',
    },
  },
  summary: {
    lead_one: 'Çalışanlar kendi Microsoft hesaplarıyla bağlanır. Şu an <b>{{count}} kişi</b> bağlı.',
    lead_other: 'Çalışanlar kendi Microsoft hesaplarıyla bağlanır. Şu an <b>{{count}} kişi</b> bağlı.',
    firm: 'Firmada açık',
    firmOffHint: 'Kapalıyken kimse kullanamaz; bağlı hesaplar korunur.',
    incompleteTitle: 'Kurulum tamamlanmadı',
    incompleteSecret: 'Doğrudan giriş için gizli anahtar eksik; o girilene kadar kimse bağlanamaz.',
    incomplete: 'Kurulum bilgileri eksik; tamamlanana kadar kimse bağlanamaz.',
    consentGranted: "Microsoft'ta yönetici onayı verildi.",
    consentGrantedText: 'Çalışanlar bağlanırken artık onay beklemez. İsterseniz bağlantıyı yeniden test edin.',
    consentDenied: 'Yönetici onayı verilmedi.',
    consentDeniedText: "Kiracınızda kullanıcı onayı kısıtlıysa çalışanlar onaysız bağlanamaz; Oppy'ye dönünce “Microsoft hesabınız bağlanamadı.” görürler. Onayı Microsoft'taki kayıtta verin ya da kurulumun 3. adımında yeniden deneyin.",
    consentRetry: '3. adımı aç',
    close: 'Kapat',
    // MsYonetimEntegrasyon's six rows in its order; the write rows' hints are the mockup's, the others taslaksız
    features: {
      title: 'Neler açık',
      mail: { title: 'Mail okuma', hint: 'Mail aramak ve okumak; kişi isteyince ekleri okumak' },
      mailSend: { title: 'Mail gönderme', hint: 'Her gönderimde çalışanın onayı istenir; bu onay kapatılamaz' },
      calendar: { title: 'Takvim okuma', hint: 'Takvime ve toplantı ayrıntısına bakmak, uygun saat bulmak (yalnız dolu/boş)' },
      calendarWrite: { title: 'Toplantı oluşturma', hint: 'Her seferinde çalışanın onayı istenir; davetler onaydan sonra gider' },
      onedrive: { title: "OneDrive'dan belge getirme", hint: "Çalışan seçtiği belgeleri Oppy'ye bir kez kopyalar" },
      sharepoint: { title: "SharePoint'ten belge getirme", hint: "Çalışan şirketin sitelerinden seçtiği belgeleri Oppy'ye bir kez kopyalar" },
      needs: { mail_read: "Önce Mail okuma'yı açın", calendar_read: "Önce Takvim okuma'yı açın" },
      entra: "Açmadan önce Entra'da Files.Read.All (ve SharePoint için Sites.Read.All) iznini ekleyin; kılavuz §1.3.",
      note: "Oppy Microsoft 365'te hiçbir şeyi silmez; mail gönderme ve toplantı oluşturma her seferinde çalışanın onayıyla olur.",
      readOnly: "Oppy Microsoft 365'te hiçbir şey göndermez, oluşturmaz ya da silmez.",
    },
    audience: {
      title: 'Kim kullanabilir',
      edit: 'Düzenle',
      everyone: 'Herkes',
      teams: 'Seçili ekipler: {{teams}}',
      noTeams: 'Seçili ekipler: henüz ekip seçilmedi, kimse kullanamaz',
      moreTeams: '{{count}} ekip daha',
      hint: 'Ekip yöneticileri kendi ekipleri için açıp kapatabilir',
      turnedOff_one: '{{teams}} ekibi kapattı',
      turnedOff_other: '{{teams}} ekipleri kapattı',
      // part 3, while a document switch is on (MsYonetimEntegrasyon)
      documents: { title: 'Alınan belgeler', hint: "Önce yalnız getiren kişiye görünür. Ekibe uyarıyla konabilir; Herkes'e yalnız süper yöneticiler koyar." },
    },
    connection: {
      title: 'Microsoft bağlantısı',
      open: 'Ayarları aç',
      method: 'Giriş',
      clientId: 'Uygulama kimliği',
      expires: 'Gizli anahtar bitişi',
      expiresNone: 'girilmedi',
      expiresSoon_one: '{{date}} · {{count}} gün kaldı',
      expiresSoon_other: '{{date}} · {{count}} gün kaldı',
      expiresToday: '{{date}} · bugün bitiyor',
      expired: '{{date}} · süresi doldu',
      noSecret: 'Gizli anahtar',
      noSecretValue: 'yok (Kodla girişte gerekmez)',
      lastOk: 'Son test başarılı · {{when}}',
      lastFailed: 'Son test başarısız · {{when}} · {{reason}}',
      never: 'Henüz test edilmedi',
      retest: 'Yeniden test et',
      matchAccount: {
        title: 'Microsoft hesabı kişinin Oppy e-postasıyla aynı olmalı',
        hint: 'Açıkken kimse bir iş arkadaşının posta kutusunu bağlayamaz (örneğin ona bir giriş kodu göndererek). Yalnız çalışanlarınızın Oppy e-postaları Microsoft adreslerinden farklıysa kapatın.',
      },
    },
    remove: {
      hint: 'Kurulumu kaldırırsanız Microsoft ayarları silinir ve herkesin Microsoft bağlantısı kaldırılır.',
      button: 'Kurulumu kaldır',
      confirmTitle: 'Microsoft 365 kurulumu kaldırılsın mı?',
      confirmBody_one:
        'Herkesin Microsoft bağlantısı kaldırılır ve anahtarı silinir (şu an {{count}} kişi bağlı). Kiracı, uygulama kimliği ve gizli anahtar da silinir. Bu geri alınamaz.',
      confirmBody_other:
        'Herkesin Microsoft bağlantısı kaldırılır ve anahtarları silinir (şu an {{count}} kişi bağlı). Kiracı, uygulama kimliği ve gizli anahtar da silinir. Bu geri alınamaz.',
    },
  },
  audienceDialog: {
    title: 'Kim kullanabilir?',
    everyoneHint: 'Firmadaki herkes. Ekip yöneticileri kendi ekipleri için kapatabilir.',
    teams: 'Seçili ekipler',
    teamsHint: 'Yalnız seçtiğiniz ekiplerdeki kişiler.',
    teamsLabel: 'Ekipler',
    search: 'Ekip ara',
    members_one: '{{count}} kişi',
    members_other: '{{count}} kişi',
    turnedOff: 'ekip yöneticisi kapattı',
    pickOne: 'En az bir ekip seçin.',
    none: 'Firmada henüz ekip yok.',
    nothingFound: 'Bu adla ekip yok.',
  },
  team: {
    note_one: 'Ekip yöneticisi olarak yalnız <b>{{teams}}</b> ekibiniz için açıp kapatabilirsiniz. Microsoft ayarlarını süper yöneticiler yönetir.',
    note_other: 'Ekip yöneticisi olarak yalnız <b>{{teams}}</b> ekipleriniz için açıp kapatabilirsiniz. Microsoft ayarlarını süper yöneticiler yönetir.',
    firmOn: 'Firmada açık',
    firmOff: 'Firmada kapalı',
    notSetUp: 'Kurulmadı',
    notSetUpText: 'Microsoft 365 firmada henüz kurulmadı. Süper yöneticiler kurup açtığında ekibiniz için buradan açıp kapatabilirsiniz.',
    for: '{{team}} ekibi için',
    on: 'Açık',
    off: 'Kapalı',
    offHint_one: "Kapatırsanız ekibinizdeki {{count}} kişi Microsoft 365'i kullanamaz; bağlı hesapları korunur.",
    offHint_other: "Kapatırsanız ekibinizdeki {{count}} kişi Microsoft 365'i kullanamaz; bağlı hesapları korunur.",
    onHint_one: "Açarsanız ekibinizdeki {{count}} kişi Microsoft 365'i kullanabilir.",
    onHint_other: "Açarsanız ekibinizdeki {{count}} kişi Microsoft 365'i kullanabilir.",
    blocked: {
      notSetUp: 'Microsoft 365 firmada henüz kurulmadı.',
      firmOff: 'Firmada kapalı; süper yöneticiler açınca ekibiniz için buradan açıp kapatabilirsiniz.',
      notAllowed: "Süper yöneticiler Microsoft 365'i yalnız seçili ekiplere açtı; bu ekip seçili değil.",
    },
    connected: 'Ekibinizde bağlı: {{connected}} / {{members}} kişi',
    none: 'Yönettiğiniz bir ekip bulunamadı.',
  },
  audit: {
    filter: { label: 'Olay', all: 'Tümü', microsoft: 'Microsoft 365' },
    note: 'Mail ve belge içerikleri burada yer almaz; yalnız ne zaman, kim, ne yaptı.',
    fields: {
      entraTenantId: 'kiracı kimliği',
      clientId: 'uygulama kimliği',
      clientSecret: 'gizli anahtar',
      signInMethod: 'giriş yöntemi',
      secretExpiresOn: 'gizli anahtar bitişi',
    },
    changed: 'Değişen: {{fields}}',
    method: { auth_code: 'Giriş: Doğrudan', device_code: 'Giriş: Kodla' },
    reset_one: '{{count}} kişinin bağlantısı kaldırıldı',
    reset_other: '{{count}} kişinin bağlantısı kaldırıldı',
    resetAll: 'Bağlı hesaplar kaldırıldı',
    removed_one: '{{count}} kişinin bağlantısı ve anahtarı silindi',
    removed_other: '{{count}} kişinin bağlantısı ve anahtarı silindi',
    removedNone: 'Bağlı kimse yoktu',
    testOk: 'Başarılı',
    testFailed: 'Başarısız: {{reason}}',
    setting: {
      enabledOn: 'Firmada açıldı',
      enabledOff: 'Firmada kapatıldı',
      mailReadOn: 'Mail okuma: açıldı',
      mailReadOff: 'Mail okuma: kapatıldı',
      calendarReadOn: 'Takvim okuma: açıldı',
      calendarReadOff: 'Takvim okuma: kapatıldı',
      matchAccountOn: 'Microsoft hesabı Oppy e-postasıyla aynı olmalı: açıldı',
      matchAccountOff: 'Microsoft hesabı Oppy e-postasıyla aynı olmalı: kapatıldı',
      // part 3 (MsDenetim: "Mail gönderme: açıldı")
      mailSendOn: 'Mail gönderme: açıldı',
      mailSendOff: 'Mail gönderme: kapatıldı',
      calendarWriteOn: 'Toplantı oluşturma: açıldı',
      calendarWriteOff: 'Toplantı oluşturma: kapatıldı',
      onedriveImportOn: "OneDrive'dan belge getirme: açıldı",
      onedriveImportOff: "OneDrive'dan belge getirme: kapatıldı",
      sharepointImportOn: "SharePoint'ten belge getirme: açıldı",
      sharepointImportOff: "SharePoint'ten belge getirme: kapatıldı",
      availability: 'Kim kullanabilir: {{from}} → {{to}}',
      teams_one: 'Seçili ekipler: {{count}} ekip',
      teams_other: 'Seçili ekipler: {{count}} ekip',
    },
    audience: { everyone: 'Herkes', teams: 'Seçili ekipler' },
    teamOn: '{{team}} ekibi için açıldı',
    teamOff: '{{team}} ekibi için kapatıldı',
    anyTeamOn: 'Bir ekip için açıldı',
    anyTeamOff: 'Bir ekip için kapatıldı',
    // the API's grantedOf words; part 3 adds sending, meetings, files and sites (MsDenetim: "mail, takvim, dosyalar")
    scopes: {
      mail: 'mail',
      takvim: 'takvim',
      calendar: 'takvim',
      gonderme: 'gönderme',
      toplanti: 'toplantı',
      dosyalar: 'dosyalar',
      siteler: 'siteler',
      mail_send: 'gönderme',
      calendar_write: 'toplantı',
      files: 'dosyalar',
      sites: 'siteler',
    },
    upgrade: 'yeni izin için yeniden bağlandı',
    deviceCode: 'kodla giriş',
    disconnected: {
      user: 'Kendisi kaldırdı · anahtar silindi',
      access_closed: 'Erişimi kapatıldığı için anahtar silindi',
      data_deleted: 'Verilerini sildiği için anahtar silindi',
      setup_changed: 'Kurulum değiştiği için anahtar silindi',
      other: 'Anahtar silindi',
    },
    signIn: {
      state_invalid: 'Giriş doğrulanamadı; yeniden başlatılması gerekti',
      access_denied: "Kişi Microsoft'ta izin vermedi",
      consent_required: 'Yönetici onayı gerekiyordu',
      personal_account: 'Kişisel Microsoft hesabı reddedildi',
      other_tenant: 'Başka bir şirketin hesabı reddedildi',
      guest_account: 'Misafir hesap reddedildi',
      wrong_account: 'Microsoft hesabı kişinin Oppy e-postasıyla eşleşmedi',
      id_token_invalid: "Microsoft'un yanıtı doğrulanamadı",
      exchange_failed: 'Microsoft girişi tamamlamadı',
      not_available: 'Kişi için kapalıydı',
      unavailable: "Microsoft'a ulaşılamadı",
      expired: 'Kodun süresi doldu',
      declined: "Kişi Microsoft'ta reddetti",
      unknown: 'Giriş tamamlanamadı',
    },
    refresh: {
      microsoft_reconnect: 'Microsoft girişi artık geçerli değil · yeniden bağlanması istendi',
      invalid_grant: 'Microsoft girişi artık geçerli değil · yeniden bağlanması istendi',
      needs_reconnect: 'Microsoft girişi artık geçerli değil · yeniden bağlanması istendi',
      password_changed: 'Parola değişti · yeniden bağlanması istendi',
      microsoft_consent_required: 'Yönetici onayı gerekiyor',
      consent_required: 'Yönetici onayı gerekiyor',
      unknown: 'Yeniden bağlanması istendi',
    },
    consentRequested: 'Bağlanırken yönetici onayı gerekti; yöneticilere bildirildi',
    notified_one: '{{count}} yöneticiye bildirim',
    notified_other: '{{count}} yöneticiye bildirim',
    tools: {
      mail_ara: 'Mail ara',
      mail_oku: 'Mail oku',
      eki_oku: 'Eki oku',
      takvime_bak: 'Takvime bak',
      toplanti_ayrintisi: 'Toplantı ayrıntısı',
      uygun_saat_bul: 'Uygun saat bul',
    },
    items_one: '{{count}} sonuç',
    items_other: '{{count}} sonuç',
    // part 3: write cards and copied documents; counts only, never a subject, a text, an address or a file name
    write: {
      product: 'Microsoft 365',
      recipients_one: '{{count}} alıcı',
      recipients_other: '{{count}} alıcı',
      external_one: '{{count}} şirket dışı',
      external_other: '{{count}} şirket dışı',
      attendees_one: '{{count}} katılımcı',
      attendees_other: '{{count}} katılımcı',
      noAttendees: 'davet yok, yalnız takvim',
      teams: 'Teams toplantısı',
      noTeams: 'Teams bağlantısı yok',
      edited: 'kartta düzenlendi',
      noContent: 'içerik kaydedilmez',
      draftLeft: "taslak Taslaklar'da kaldı",
      notSent: {
        cancelled: "Kullanıcı vazgeçti · onay kartında 'Vazgeç'",
        expired: 'Kartın süresi doldu',
        stopped: 'Durduruldu',
        failed: 'Gönderilemedi',
        unknown: 'Gönderilip gönderilmediği bilinmiyor',
      },
      notCreated: {
        cancelled: "Kullanıcı vazgeçti · onay kartında 'Vazgeç'",
        expired: 'Kartın süresi doldu',
        stopped: 'Durduruldu',
        failed: 'Oluşturulamadı',
        unknown: 'Oluşturulup oluşturulmadığı bilinmiyor',
      },
      codes: {
        draft_changed: "taslak Outlook'ta değişmişti",
        verify_mismatch: "Outlook'taki taslak karttakinden farklıydı",
        microsoft_busy: 'Microsoft çok yoğundu',
        microsoft_forbidden: 'Microsoft izin vermedi',
        microsoft_not_found: 'Microsoft maili bulamadı',
        microsoft_rejected: 'Microsoft isteği kabul etmedi',
        microsoft_failed: "Microsoft'ta bir sorun oldu",
        microsoft_scopes_required: 'yeni izin gerekiyordu',
        recipient_not_allowed: 'alıcı deneme listesinde değildi',
        feature_off: 'firma kapatmıştı',
        timeout: "Microsoft'un yanıtı gelmedi",
      },
    },
    documents: {
      source: { onedrive: 'OneDrive', sharepoint: 'SharePoint', outlook: 'Outlook eki', mixed: 'Birden çok kaynak' },
      files_one: '{{count}} dosya',
      files_other: '{{count}} dosya',
      to: '{{files}} → {{place}}',
      place: {
        user: 'Kişisel',
        team: 'Ekip: {{name}}',
        workspace: 'Çalışma alanı: {{name}}',
        teamAny: 'Ekip',
        workspaceAny: 'Çalışma alanı',
        organization: 'Herkes',
        conversation: 'Bu sohbet',
      },
      acknowledged: '(uyarı onaylandı)',
      refused_one: '{{count}} dosya alınamadı',
      refused_other: '{{count}} dosya alınamadı',
      duplicate_one: '{{count}} dosya zaten vardı',
      duplicate_other: '{{count}} dosya zaten vardı',
      refetch: { ok: 'güncellendi', unchanged: 'kaynakta değişiklik yoktu', failed: 'yeniden alınamadı' },
      // why a "Yeniden al" failed: the worker's document codes (DOCUMENT_SOURCE_ERRORS), as Belgeler words them
      codes: {
        source_forbidden: "dosyayı Microsoft'ta görme izni yoktu",
        source_not_found: "dosya Microsoft'ta bulunamadı; silinmiş ya da taşınmış olabilir",
        source_too_large: 'dosya boyut sınırını aşıyordu',
        source_unsupported: 'dosya türü okunamıyordu',
        source_malware: 'Microsoft dosyada zararlı yazılım buldu',
        source_empty: 'dosya boştu',
        source_off: "Microsoft 365'ten belge getirme kapalıydı",
        source_not_connected: 'Microsoft hesabı bağlı değildi',
        microsoft_scopes_required: 'yeni izin gerekiyordu',
        source_unavailable: "Microsoft'a ulaşılamadı",
      },
    },
  },
};
